<div #css class="container component-selector-select">
  <div class="row bg-gradient component-header-size">
    <h1 class="component-header-title">{{ cardTitle.title | uppercase}}</h1>
  </div>
  <div class="row component-body-size" *ngIf="cardTitle.showInput">
    <mat-form-field class="component-form-size m-option" matTooltipPosition="above"
      matTooltip="{{ auxFilteredTooltipAssets }}" [ngClass]="{'existValue' : auxFilteredAssets.length > 0}">
      <span class="span-value" *ngFor="let item of auxFilteredAssets;let first = first; let i = index; let last = last">{{first
        ? item.symbol.toLocaleUpperCase() : (i < 4 ? ', ' + item.symbol : ( last ? '...' : '' ))}}</span>
      <mat-select class="select-multiple-auto" (click)="readjustHeight()" (openedChange)="readjustHeight()"
        (selectionChange)="onchangeSymbol()" [compareWith]="compareFn" placeholder="adicione um ou vários ativos"
        [(ngModel)]="assetsWorksheet" (click)="clickSelect()" multiple>
        <mat-option disabled="disabled" class="component-selector-select-mat-option mat-option first-option">
          <mat-icon class="search-icon">search</mat-icon>
          <input id="inputSelect" class="input-option" type="text" matInput placeholder="Digite um ativo"
            (keyup)="onAutoCompletAsset($event)" ondragstart="return false;" ondrop="return false;"
            style="text-transform:uppercase" (keydown.enter)="onInputEnter($event)" style="position: absolute">
        </mat-option>
        <mat-option class="component-selector-select-mat-option option-select" *ngFor="let item of filteredAssets"
          [value]="item">{{ item.symbol | uppercase }}</mat-option>
      </mat-select>
      <mat-autocomplete autoActiveFirstOption #issuingAsset="matAutocomplete"></mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="row component-body-size" *ngIf="!cardTitle.showInput"></div>
  <button mat-mini-fab class="button-plus" [ngClass]="{'button-check' : button_selected}" (click)="addComponent()"
    [disabled]="loading"></button>
</div>